import { IMessage } from '../../../../interfaces/entities';
import { useAuth } from '../../../../store/auth';
import { useMailStore } from '../store/mail.store';
import { formatDate } from '../utils';
import { Avatar } from './Avatar';
import {BsCloudDownload} from 'react-icons/bs';
import {downloadFile} from '../../../../utils/downloadFile';

interface MessageBubbleProps {
  isMe?: boolean;
  message?: IMessage;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ isMe, message }) => {
  const { selectedUser } = useMailStore();
  const { user } = useAuth();

  const getAvatarUrl = () => {
    if (isMe && user?.photo) return user.photo;
    if (selectedUser?.photo) return selectedUser.photo;
    return '';
  };

  return (
    <div className={`flex flex-row gap-3 ${isMe && 'flex-row-reverse'} my-1`}>
      <div className="h-12 w-12 flex-shrink-0">
        <Avatar url={getAvatarUrl()} />
      </div>

      <div className="flex max-w-[70%] flex-col">
        <div className={`${isMe ? 'bg-[#0C1FAA] text-white' : 'bg-[#F8F9FA] text-[#373D43]'} rounded-lg p-4 shadow-sm`}>
          {message?.type === 'message' && <p className="text-sm leading-relaxed">{message?.content}</p>}
          {message?.type === 'file' && (
            <p
              onClick={() => downloadFile(message?.content, 'file')}
              rel="noreferrer"
              className="flex cursor-pointer items-center text-sm underline"
            >
              <BsCloudDownload className='mr-2' size={20}/>
              File
            </p>
          )}
        </div>
        <span className={`mt-1 text-xs text-[#727272] ${isMe ? 'text-right' : 'text-left'}`}>
          {message?.created_at && formatDate(message.created_at)}
        </span>
      </div>
    </div>
  );
};

export { MessageBubble };
